export default function ClientTopBanner({ user, project }) {
  const name = user?.first_name || user?.display_name || "there";
  return (
    <div className="client-card top-banner">
      <span className="client-eyebrow">Client Dashboard</span>
      <h1>Welcome back, {name}</h1>
      {project ? (
        <p>{project.project_name} is currently in <strong>{project.current_phase}</strong>.</p>
      ) : (
        <p>Your approved projects and next steps will appear here.</p>
      )}
    </div>
  );
}